import {PumpSensorHelperModel} from "../pump-sensor-helper-model";

export class SensorsPumpModel {
  pumpSensors: PumpSensorHelperModel[];

  constructor() {
    this.pumpSensors = [];
  }

  public static initialize(model: SensorsPumpModel): void {
    if (!model.pumpSensors) {
      model.pumpSensors = [];
    }
  }
}
